import { ModalPopup } from "@vernost_dev/vms-react-components/dist/ModalPopup";

export const VmsModalPopup = ({
  isOpen = false,
  overlayClassName,
  onAfterOpen,
  onAfterClose,
  onRequestClose,
  shouldCloseOnOverlayClick = true,
  shouldCloseOnEsc = false,
  children,
  isMobileView,
  closeButton = true,
  closeButtonAlignment = "left",
  additionalClassName,
  additionalStyle,
  animationType,
  customiseCloseIcon,
  modalHeaderCustomView,
  modalFooterCustomView
}) => {
  return (
    <ModalPopup
      isOpen={isOpen}
      overlayClassName={overlayClassName}
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      shouldCloseOnEsc={shouldCloseOnEsc}
      isMobileView={isMobileView}
      closeButton={closeButton}
      closeButtonAlignment={closeButtonAlignment}
      additionalClassName={additionalClassName}
      additionalStyle={additionalStyle}
      animationType={animationType}
      customiseCloseIcon={customiseCloseIcon}
      modalHeaderCustomView={modalHeaderCustomView}
      modalFooterCustomView={modalFooterCustomView}
    >
      {children}
    </ModalPopup>
  );
};
